import { createCustomEnum } from "./customEnum";

const TerminalStatus = createCustomEnum({
	Pending: {
		name: "pending",
		value: "pending",
		displayName: "Pending",
	},
	Draft: {
		name: "draft",
		value: "draft",
		displayName: "Draft",
	},
	Complete: {
		name: "complete",
		value: "complete",
		displayName: "Complete",
	},
});

export default TerminalStatus;
